import React, { useState, Fragment, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";

import { setChangesModalData } from "../../actions/supporters";

import Button from "../Button";

const getTextStyle = (error, status) => {
  if (status === "New") {
    return { color: "#49b949" };
  }

  if (error) {
    return { color: "rgba(246, 70, 98, 0.9)" };
  }
  return null;
};

const getStatus = (cell) => {
  const { date_end, date_modified, date_created, frequency, status } =
    cell.row.original;

  // one-off support with an end date has been processed...
  if (date_end && frequency === "One-Off") {
    return { value: "Processed", tip: "One-Off support has been processed" };
  }

  const now = moment();

  // if there is any value for date_end this donation has stopped...
  if (date_end && now.isAfter(moment(date_end))) {
    return {
      value: "Ceased",
      tip: "No longer providing support",
    };
  }

  // if this record was created in the last month, we'll call it "new" unless it's been modified....
  if (
    now.diff(date_created, "months") === 0 &&
    moment(date_modified).diff(date_created, "seconds") === 0
  ) {
    return { value: "New", tip: "Created in the last month" };
  }

  // if this record was modified in the last 3 months, we'll call it "Updated"
  if (moment(date_modified).diff(date_created, "months") <= 3) {
    return { value: "Updated", tip: "Updated in the last 3 months" };
  }

  return {
    value: status,
    tip: status === "Active" ? "Currently providing support" : "",
  };
};

const SupportChangesTableCell = ({ cell, setModalIsOpen }) => {
  const [error, setError] = useState(false);
  const [status, setStatus] = useState({ value: "", tip: "" });

  useEffect(() => {
    if (
      (!cell.row.original.changes || cell.row.original.changes.length === 0) &&
      cell.row.original.frequency !== "One-Off"
    ) {
      setError("No logged changes found");
      setStatus({
        value: cell.row.original.status,
        tip: "No logged changes found",
      });
    } else {
      setStatus(getStatus(cell));
    }
  }, [cell]);

  const handleClick = useCallback(() => {
    if (error) {
      return null;
    }
    const { fullname, changes } = cell.row.original;
    if (!changes || changes.length === 0) {
      return null;
    }
    setModalIsOpen(changes, fullname, true);
    return null;
  }, [cell, error, setModalIsOpen]);

  return (
    <Fragment>
      <Button
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex={0}
        style={getTextStyle(error, status.value)}
        data-tip={status.tip}
      >
        {status.value}
      </Button>
    </Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setModalIsOpen: (data, fullname, isOpen) =>
    dispatch(setChangesModalData(data, fullname, isOpen)),
});

SupportChangesTableCell.propTypes = {
  cell: PropTypes.objectOf(PropTypes.any).isRequired,
  setModalIsOpen: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(SupportChangesTableCell);
